<template>
  <div>
    <vs-popup class="rm-catalogue-errors-popup"
              id="popup"
              :title='`${title} MISSING ELEMENTS`'
              :active.sync="open"
              :buttons-hidden="true">

      <vs-list class="my-2">
        <vs-list-item v-for="(error, index) in errors" :key="index" :title="`${index + 1} - ${error}`"/>
      </vs-list>
    </vs-popup>

  </div>
</template>

<script>

export default {
  name: "RmCatalogueErrorPopUp",
  data() {
    return {
      errors: [],
      title: '',
      open: false,
    }
  },
  methods:{
    async openPopUp(errors, title){
      if(title === 'RAW MATERIAL') {
        this.errors = [...errors.compulsory, ...errors.warning]
      } else {
        this.errors = errors
      }
      this.title = title
      this.open = true
    },
  }
}
</script>

<style scoped>

.rm-catalogue-errors-popup >>> .vs-popup {
  min-width: 50% !important;
}

</style>
